import { Permission, RFIStatus } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { useRFITrackerContext } from '../../../../RFITrackerContext'
import { useSoftRemoveRequestForInformationMutation } from 'schema'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useClosedDisabledMessage } from 'components/CIMSTable/common/hooks/useClosedDisabledMessage'
import { RequestForInformation } from '../../../../RFITrackerContext/types'

export function useRemoveOptions(): RemoveRowActionOptions<RequestForInformation> {
  const { refetch } = useRFITrackerContext()
  const [remove] = useSoftRemoveRequestForInformationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveRequestForInformation: {
        requestForInformation: { formattedNumber },
      },
    }) => simpleRemoveNotification(formattedNumber),
  })
  return {
    permission: Permission.RemoveRestoreRequestForInformation,
    disabled: useClosedDisabledMessage('removed', [
      RFIStatus.Closed,
      RFIStatus.Unlocked,
    ]),
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
